import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=2e4a4619&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)


    import installComponents from "!/builds/rentmagic/rentmagic.website.vue.west-vlaanderen/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BCol, BFormInput, BFormGroup, BFormTextarea, BFormText, BButton, BInputGroupAppend, BInputGroup, BFormCheckbox, BRow, BAlert, BForm, BCard, BContainer} from 'bootstrap-vue'
    installComponents(component, {BCol, BFormInput, BFormGroup, BFormTextarea, BFormText, BButton, BInputGroupAppend, BInputGroup, BFormCheckbox, BRow, BAlert, BForm, BCard, BContainer})
    

export default component.exports